import { useEffect, useRef } from "react";
import { Button } from "primereact/button";
import { Card } from "primereact/card";
import { authApi } from "../../services/authentication/authApi";
import { ProgressSpinner } from "primereact/progressspinner";
import { useNavigate } from "react-router";
import { useGoogleLogin } from "@react-oauth/google";
import { oAuthApi } from "../../services/authentication/oAuthApi";
import { selectIsAuthenticated } from "../../services/authentication/authSlice";
import { useSelector } from "react-redux";
import { Toast } from "primereact/toast";

const Login = () => {
  const toast = useRef<Toast>(null);
  const navigate = useNavigate();
  const [login, { isLoading: isLoginLoading }] = authApi.useLoginMutation();
  const [sendResponse] = oAuthApi.useSubmitGoogleResponseMutation();
  const isAuthenticated = useSelector(selectIsAuthenticated);

  useEffect(() => {
    if (isAuthenticated) {
      const redirectPath = sessionStorage.getItem("redirectPath");
      if (redirectPath) {
        sessionStorage.removeItem("redirectPath");
        navigate(redirectPath);
      } else {
        navigate("/dashboard");
      }
    }
  }, [isAuthenticated, navigate]);

  if (isLoginLoading) return <ProgressSpinner />;

  const googleLogin = useGoogleLogin({
    onSuccess: (codeResponse) => {
      sendResponse(codeResponse);
    },
    onError: (error) => {
      console.error(error);
      toast.current?.show({ severity: "error", summary: "Грешка", detail: "Неуспешен вход." });
    },
    flow: "auth-code",
    scope:
      "openid profile email https://www.googleapis.com/auth/userinfo.profile https://www.googleapis.com/auth/userinfo.email",
  });

  return (
    <div style={{ display: "flex", minHeight: "100vh", overflow: "hidden" }}>
      <div style={{ flex: "0 0 30%", overflowY: "auto" }}>
        <Card style={{ height: "100%" }}>
          <div style={{ textAlign: "center", marginBottom: "8rem" }}>
            <div style={{ marginBottom: "2rem" }}>
              <img src="tru.png" alt="Logo" style={{ width: "12rem", margin: "0 auto" }} />
              <img src="/trakia.png" alt="ТРАКИЙСКИ УНИВЕРСИТЕТ" style={{ width: 397, height: 31 }} />
            </div>
            <h2 className="font-normal text-3xl mb-3 mt-0 py-0 uppercase">Студентска информационна система</h2>

            <Button
              label="Вход в системата"
              icon="pi pi-google"
              onClick={googleLogin}
              className="p-button-outlined p-button-rounded w-full p-3 mt-3 text-xl"
            />
          </div>
        </Card>
      </div>
      <div style={{ flex: "1", overflow: "hidden" }}>
        <img src="sideImage.png" alt="Side Image" style={{ objectFit: "cover", height: "100%", width: "100%" }} />
      </div>
      <Toast ref={toast} />
    </div>
  );
};

export default Login;
